










import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import { SharedModule } from '@/shared/store/shared-module'
import RespondecoOfferSelect from '@/shared/components/respondeco-offer-select.vue'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { DialogService } from '@/shared/dialog/dialog-service'
import RespondecoDialog from '@/main/dialog.vue'
import RespondecoDialogButtons from '@/main/dialog-buttons.vue'
import RespondecoDialogButton from '@/main/dialog-button.vue'

@Component({
  components: {
    RespondecoDialogButton,
    RespondecoDialogButtons,
    RespondecoDialog,
    RespondecoOfferSelect,
    RespondecoForm,
  },
  data() {
    return {
      offer: undefined,
    }
  },
})
export default class AddOfferDialog extends Vue {
  public static readonly dialogName: string = 'ADD_OFFER_DIALOG'

  public offer?: OfferLite

  private dialogService = Injector.get(DialogService)
  private sharedModule = Injector.get(SharedModule)

  get offers(): OfferLite[] {
    return this.sharedModule.data.offers
  }

  public initialize() {
    this.sharedModule.fetchSharedOffers()
  }

  public submit() {
    this.$emit('input', this.offer)
    this.dialogService.hide(AddOfferDialog.dialogName)
  }
}
